export default __webpack_public_path__ + "static/media/manual-icon.19f9e5be.svg";